import axios from 'axios';
import { baseApi, token } from '../../../services/Apis';

export const usersDeleteApi = `${baseApi}/user-deletion-requests`;

export const getAllUsersDeleteService = async (params) => {
  const res = await axios.get(usersDeleteApi, {
    headers: await token({}),
    params,
  });
  return res;
};

export const saveUsersDeleteService = async (id, data) => {
  if (data.file) {
    const formData = new FormData();

    if (data.userTypes?.length) {
      for (const userType of data.userTypes) {
        formData.append('userTypes[]', userType);
      }
      delete data.userTypes;
    }
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    data = formData;
  } else {
    delete data.file;
  }

  let res;
  if (id) {
    res = await axios.put(`${usersDeleteApi}/${id}`, data, {
      headers: await token({
        isFormData: !!data.file,
      }),
    });
  } else {
    res = await axios.post(`${usersDeleteApi}`, data, {
      headers: await token({
        isFormData: !!data.file,
      }),
    });
  }
  return res.data;
};

export const getOneUsersDeleteService = async (id) => {
  const res = await axios.get(`${usersDeleteApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};

export const deleteUsersDeleteService = async (id) => {
  const res = await axios.delete(`${usersDeleteApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};
